// @flow
import type {BrontoParamsType} from 'reducers/analytics/analytics/analyticsType';
import DirectAdd from '@optimaxdev/bronto-direct-add';

import {DirectAdd as DirectAddOld} from './direct';

/**
 * Send bronto direct params
 * @param {object} params - bronto params
 * @param {string} id - bronto jsId
 * @param {boolean} [force=false] - force bronto to add even if it is already there
 */
export function sendBrontoParams(
    params: BrontoParamsType,
    id: string | null,
    force: boolean = false,
) {
    const da = new DirectAddOld({id});
    Object.keys(params || {}).forEach((key: string) => {
        const value = params[key];

        if (key === 'affiliate_code') {
            da.setAffiliate(value);
        } else {
            da.set(key, value);
        }
    });

    da.saveData(force);
}

/**
 * Set bronto keys
 * @param {BrontoParamsType} params - bronto params
 * @param {string} id - bronto jsId
 */
export function setBrontoKeys(params: BrontoParamsType, id: string | null) {
    DirectAdd.setBrontoKey(id);
    Object.keys(params || {}).forEach((key: string) => {
        const value = params[key];

        if (key === 'affiliate_code') {
            DirectAdd.setAffiliate(value);
        } else {
            DirectAdd.set(key, value);
        }
    });
}

/**
 * Send data to Bronto
 * @param {BrontoParamsType} params - bronto params
 * @param {string} id - bronto jsId
 */
export function sendDataToBronto(params: BrontoParamsType, id: string | null) {
    setBrontoKeys(params, id);
    DirectAdd.saveData(true);
}
